<template>
	<div class="ptrl-20-16 box-s">
     <div class="title">请输入兑换码</div>
		<ul class="list_every bg_f plr-16">
      <li class="flexs flex-jus h60 bb-E c1 fz-14">
        <div class="flexs flex1 flex-end">
          <input placeholder="兑换码" v-model="code" placeholder-class="c2" class="text-center flex1 code" type="text">
          <div class="wh_8_14"></div>
        </div>
      </li>
    </ul>

    <div class="btn_contain">
      <div class="blue_btn" @click="submit">
        确认兑换
      </div>
    </div>
   
    <load :loadFlag="loadFlag"></load>
	</div>
</template>
<script>
	import load from "@/components/loading"
  import { exchangecode } from '@/api/api.js'
	export default {
		
		data() {
			return {
        code: '',
        loadFlag: false,
			};
		},
		created() {
		},
    mounted(){
    },
    components: {
      load
		},
    methods: {
      
      // 提交按钮
      async submit(){
        if(!this.code){
          this.$toast('请填写兑换码')
          return false
        }
        console.log('duihuan')
        this.loadFlag = true
        const res = await exchangecode({code:this.code})
        this.loadFlag = false
        if(res.code == 1000){
          this.$toast.success('兑换成功')
          // /localStorage.setItem('merFlag', 1)
          setTimeout(()=>{ 
            this.$router.replace('/member')
          },500)
        }else {
					 this.$toast(res.msg)
				}
      }
    }
	}
</script>
<style lang="less" scoped>
  .title{
    font-size: 18px;
    font-weight: bold;
   color:#497CFF;
   text-align: center;
   margin-bottom: 20px;
   margin-top: 80px;
  }
  .code{
    font-size: 18px;
  }
  .c2{
    font-size: 18px;
  }
	/deep/.van-uploader__upload {
    border-radius: 50%;
    width: 34px;
    height: 34px;
  }

  /deep/.van-uploader__upload-icon {
    font-size: 15px;
  }

  /deep/.van-uploader__upload {
    margin: 0;
    margin-right: 10px;
  }

  /deep/.van-uploader__preview-image {
    border-radius: 50%;
    width: 34px;
    height: 34px;
  }

  /deep/.van-uploader__file {
    border-radius: 50%;
    width: 34px;
    height: 34px;
  }

  /deep/ .van-uploader__preview {
    margin: 0;
    margin-right: 10px;
  }

  .imgpre {
    border-radius: 50%;
    width: 34px;
    height: 34px;
  }
  .img_contain {
    border-radius: 50%;
    width: 34px;
    height: 34px;
    margin-right: 10px;
  }

  .delImg {
    position: absolute;
    width: 16px;
    height: 16px;
    top: -7px;
    right: 9px;
  }

  /deep/.van-uploader__file-icon {
    display: none;
  }
</style>
